ApiAjax = require 'app/scripts/network/api-ajax'
Auth = require 'app/scripts/db/auth'
Dates = require 'app/scripts/lib/dates'
PostRender = require 'app/scripts/views/lib/post-render'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
templates = require 'app/scripts/views/internal/templates'
Util = require 'app/scripts/lib/util'
{ track, trackUe, Noun, Verb } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'

module.exports = class ConfirmEmailBannerView extends WarningBannerView

  initialize: ->
    # This updates the daysLeft param for Aa soft email verification
    # without the user doing a hard reload
    PostRender.enqueue "confirmEmailBanner_#{ @cid }", =>
      @makeDebouncedMethods 'updateDaysLeft'
      @listenTo Dates, 'renderInterval', @updateDaysLeftDebounced
      return

    knownEmailProviders =
      gmail: /@(gmail|googlemail).com$/
      yahoo: /@(yahoo|ymail).com$/
      live: /@(hotmail|live).com$/
      mac: /@(me|mac).com$/

    emailProviderInboxes =
      gmail: 'http://gmail.com'
      yahoo: 'http://mail.yahoo.com'
      live: 'http://live.com'
      mac: 'https://www.icloud.com/'

    for key, matcher of knownEmailProviders
      if matcher.test(@model.get('email'))
        @emailInboxUrl = emailProviderInboxes[key]
        break

    if !@emailInboxUrl?
      ApiAjax
        url: '/checkYourEmail'
        data: { email: @model.get('email') }
        dataType: 'json'
        success: (data) =>
          if data.error?
            return
          @emailInboxUrl = data.url
          @render()

  events:
    'click .js-resend-confirmation-email': 'trackResendEmail'
    'click .js-check-inbox': 'trackCheckInbox'

  trackResendEmail: (e) ->
    trackUe({
      category: Noun.CONFIRM_BANNER,
      verb: Verb.CLICKS,
      directObj: Noun.RESEND_EMAIL,
      method: "by clicking resend email link in confirm email banner",
    })

    Analytics.sendUIEvent
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'resendEmailLink',
      source: 'emailVerificationBanner'

  trackCheckInbox: (e) ->
    trackUe({
      category: Noun.CONFIRM_BANNER,
      verb: Verb.CLICKS,
      directObj: Noun.CHECK_INBOX,
      method: "by clicking check inbox link in confirm email banner",
    })

    Analytics.sendUIEvent
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'checkInboxLink',
      source: 'emailVerificationBanner'

  trackForcedLogout: ->
    track "Log Out"

    Analytics.sendTrackEvent
      action: 'loggedOut',
      actionSubject: 'member',
      source: 'emailVerificationBanner'


  getDaysLeft: ->
    DAY = 1000 * 60 * 60 * 24
    createdDate = Util.idToDate(@model.get('id'))
    currentDate = new Date()
    # User has 14 days to confirm their account before getting forced logged out
    daysLeft = 14 - Math.round((currentDate.getTime() - createdDate.getTime()) / DAY)
    return daysLeft

  updateDaysLeft: ->
    if @model.get('isAaMastered')
      newDaysLeft = @getDaysLeft()
      if newDaysLeft == @model.get('daysLeft')
        return @
      @model.update('daysLeft', newDaysLeft)
      @render()

  render: ->
    data = @model.toJSON()
    data.isAaMastered = @model.get('isAaMastered')

    if @emailInboxUrl?
      data.emailInboxUrl = @emailInboxUrl
      data.knownEmailProvider = true

    if data.isAaMastered
      data.daysLeft = @getDaysLeft()
      @model.set('daysLeft', data.daysLeft)
      # Once user hits soft email threshold, they are forced
      # logged out of their account and must then hard email verify
      if (data.daysLeft == 0)
        Auth.logoutPost()
        trackForcedLogout()

    @$el.html(
      templates.fill(
        'header_warning_banner',
        data
      )
    )

    @
